import { actions as openItemActions } from '../actions/openItem';

const initialState = {
  isLoading: false,
  isLoadOpenItemSuccess: false,
  isLoadOpenItemFailed: false,

  isCreatingOpenItem: false,
  isCreateOpenItemSuccess: false,
  isCreateOpenItemFailed: false,

  isUpdatingOpenItem: false,
  isUpdateOpenItemSuccess: false,
  isUpdateOpenItemFailed: false,

  openItems: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case openItemActions.loadingOpenItem: {
      return {
        ...state,
        isLoading: true,
        isLoadOpenItemSuccess: false,
        isLoadOpenItemFailed: false,
      };
    }

    case openItemActions.loadOpenItemSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoadOpenItemSuccess: true,
        isLoadOpenItemFailed: false,
        ...payload,
      };
    }

    case openItemActions.loadOpenItemFailed: {
      return {
        ...state,
        isLoading: false,
        isLoadOpenItemSuccess: false,
        isLoadOpenItemFailed: true,
      };
    }

    case openItemActions.creatingOpenItem: {
      return {
        ...state,
        isCreatingOpenItem: true,
        isCreateOpenItemSuccess: false,
        isCreateOpenItemFailed: false,
      };
    }

    case openItemActions.createOpenItemSuccess: {
      return {
        ...state,
        isCreatingOpenItem: false,
        isCreateOpenItemSuccess: true,
        isCreateOpenItemFailed: false,
      };
    }

    case openItemActions.createOpenItemFailed: {
      return {
        ...state,
        isCreatingOpenItem: false,
        isCreateOpenItemSuccess: false,
        isCreateOpenItemFailed: true,
      };
    }

    case openItemActions.updatingOpenItem: {
      return {
        ...state,
        isUpdatingOpenItem: true,
        isUpdateOpenItemSuccess: false,
        isUpdateOpenItemFailed: false,
      };
    }

    case openItemActions.updateOpenItemSuccess: {
      return {
        ...state,
        isUpdatingOpenItem: false,
        isUpdateOpenItemSuccess: true,
        isUpdateOpenItemFailed: false,
      };
    }

    case openItemActions.updateOpenItemFailed: {
      return {
        ...state,
        isUpdatingOpenItem: false,
        isUpdateOpenItemSuccess: false,
        isUpdateOpenItemFailed: true,
      };
    }

    default:
      return state;
  }
};
